import { render, staticRenderFns } from "./userTrain.vue?vue&type=template&id=29594070&scoped=true&"
import script from "./userTrain.vue?vue&type=script&lang=js&"
export * from "./userTrain.vue?vue&type=script&lang=js&"
import style0 from "./userTrain.vue?vue&type=style&index=0&id=29594070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29594070",
  null
  
)

export default component.exports